<template>
  <el-calendar v-loading="loading" :first-day-of-week="0" v-model="date">
    <template slot="dateCell" slot-scope="{ date, data }">
      <label>{{ date.getDate() }}</label>
      <p class="report">
        <el-tag size="mini" v-for="(item, index) in getReprts(data.day)" :key="index"
          :effect="item.Reviews > 0 ? 'dark' : 'light'" @click="onReport(item)">
          {{ $utils.meta.format("report-type", item.Type) }}
        </el-tag>
      </p>
      <popover :rows="getSchedules(data.day)" />
    </template>
  </el-calendar>
</template>

<script>
import reportpage from "@/views/job/report/detail.vue";
export default {
  components: {
    popover: () => import("./_popover.vue"),
  },
  data() {
    return {
      loading: false,
      date: new Date(),
      schedules: [],
      reports: [],
      queryParams: {
        user: JSON.parse(localStorage.getItem("user"))?.Id,
      },
    };
  },
  computed: {
    //获取当天的数据
    getSchedules() {
      return (day) => {
        var rows = this.schedules.filter(
          (row) =>
            this.$utils.common.parseTime(row?.ExecTime ?? row?.PlanTime) == day
        );
        return rows;
      };
    },
    getReprts() {
      return (day) => {
        var rows = this.reports.filter(
          (row) => this.$utils.common.parseTime(row.LastDate) == day
        );
        return rows;
      };
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    //获取数据
    loadData() {
      this.loading = true;
      this.$apis.job.schedule
        .list(this.queryParams)
        .then((res) => {
          this.schedules = res.Items;
          return this.$apis.job.report.list(this.queryParams);
        })
        .then((res) => {
          this.reports = res.Items;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //查看报告详情
    onReport(row = {}) {
      this.$layer.iframe({
        title: "工作总结详情",
        area: ["640px", "auto"],
        content: {
          content: reportpage,
          parent: this,
          data: {
            id: row?.Id,
          },
        },
      });
    },
  },

  watch: {
    date(n, o) {
      if (n.getFullYear() != o.getFullYear() || n.getMonth() != o.getMonth()) {
        let y = n.getFullYear(),
          m = n.getMonth();
        this.queryParams = {
          timespan: [
            this.$utils.common.parseTime(new Date(y, m, 1)),
            this.$utils.common.parseTime(new Date(y, m + 1, 0)),
          ],
        };
        this.loadData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-calendar {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;

  :deep(&__body) {
    padding: 20px;

    .el-calendar-table {
      height: 100%;
    }

    .el-calendar-day {
      height: 100%;
      position: relative;
    }
  }

  .report {
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px;
  }
}
</style>
